import { SVGProps } from "react";

const STIUdemy = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Udemy" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#fff" /><path fill="#a435f0" d="M256 121.5l-94.5 57v-57l94.5-57 94.5 57v57z" /><path d="M161.5 226.5h49.5V352a45 49 0 0090 0V226.5h49.5V356a94.5 91.5 0 01-189 0z" /></svg>;

export { STIUdemy };